import React, { useMemo } from "react"
import Modal from "react-modal"
import { IoCloseOutline } from "react-icons/io5"
import { useKonva } from "../../context/KonvaContext"
import { generateTurfDescription, totalPiecesCalculation } from "../../utils/calculationUtils"

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
    },
}

const TotalAreaCalculationModal = (props) => {
    const { open, onClose } = props
    const { shapeData } = useKonva()

    const convertedShapeData = useMemo(() => {
        return Object.entries(shapeData).map(([key, value]) => value)
    }, [shapeData])

    const turfCalucaltion = useMemo(() => {
        return convertedShapeData.map((shape) => {
            if (!shape?.currentSelectedDimension) return null
            const { area, width, height, id } = shape?.currentSelectedDimension
            const shapeId = id
            const shapeArea = area

            return {
                shapeId,
                shapeArea,
                height,
                width
            }
        })
    }, [convertedShapeData])

    return (
        <Modal style={customStyles} isOpen={open} onRequestClose={onClose}>
            <div className="closeIconWrapper toolbar">
                <h4 className='suggestHead'>You require following pieces of turf : </h4>
                <button onClick={onClose}>
                    <IoCloseOutline />
                </button>
            </div>
            <div className="areaDescriptionWrapper">
                {turfCalucaltion?.map((shapeInfo,index) => {
                    if (!shapeInfo) return <span key={index}></span>
                    const { width, height, shapeArea, shapeId } = shapeInfo
                    return (
                        <div key={shapeId} className='areaDesSubWrapper'>
                            <h5 className='suggestHead'>{`For area ${shapeArea} : `}</h5>
                            <span className='reqPiecesDes'>
                                {generateTurfDescription(totalPiecesCalculation(width,height))}
                            </span>
                        </div>
                    )
                })}
            </div>
        </Modal >
    )
}

export default TotalAreaCalculationModal